import { Field, TextInput, TextArea, Checkbox, Callout, EstadoRow } from "../../product_config/formkit";
import { VALIDACION_SISTEMAS, VALIDACION_EXTERNA_DEFAULT, nuevaValidacionExterna } from "./calculatorConfigSchema";

// Etiquetas de los sistemas que flow sabe consultar. La lista de valores vive en
// el schema; acá solo se les pone nombre. Un sistema que no esté en el resolver
// de flow no se puede ofrecer: haría fallar toda cotización del plan con 502.
const SISTEMA_LABEL = {
  SISGEN: "SISGEN",
  compania: "Compañía",
};

export default function ValidacionExternaConfig({ config, onChange }) {
  const v = config?.validacionExterna;
  const activo = !!v;
  const sistemas = Array.isArray(v?.sistemas) ? v.sistemas : [];

  const toggle = (on) =>
    onChange("validacionExterna", on ? nuevaValidacionExterna() : null);

  const toggleSistema = (nombre, on) => {
    const siguiente = on
      ? [...VALIDACION_SISTEMAS].filter((s) => s === nombre || sistemas.includes(s))
      : sistemas.filter((s) => s !== nombre);
    onChange("validacionExterna.sistemas", siguiente);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <EstadoRow
        titulo="Pedir el RUT para cotizar"
        texto="El cotizador de flow muestra el campo RUT en el miniform y no entrega precios sin él."
        on={activo}
        onChange={toggle}
      />

      {!activo && (
        <Callout tone="info" title="Este plan no pide RUT al cotizar">
          El cliente igual entrega su RUT al contratar. Enciéndelo solo si el precio
          depende de quién pregunta.
        </Callout>
      )}

      {activo && (
        <>
          <Field
            label="Sistemas que se consultan"
            hint="Se cotiza solo si el RUT no está bloqueado en ninguno de los marcados."
            full
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {VALIDACION_SISTEMAS.map((nombre) => (
                <Checkbox
                  key={nombre}
                  id={`vext-sistema-${nombre}`}
                  checked={sistemas.includes(nombre)}
                  onChange={(checked) => toggleSistema(nombre, checked)}
                  label={SISTEMA_LABEL[nombre] || nombre}
                />
              ))}
            </div>
          </Field>

          {sistemas.length === 0 && (
            <Callout tone="warn" title="Sin ningún sistema marcado no se verifica nada">
              El miniform pedirá el RUT y comprobará que el dígito verificador sea
              correcto, pero nadie evaluará si esa persona puede contratar: cotizan
              todos. Marca al menos un sistema, o apaga el RUT si no lo necesitas.
            </Callout>
          )}

          <Field
            label="Título del mensaje de bloqueo"
            hint="Lo lee la persona cuyo RUT quedó bloqueado. Dile qué pasa, no por qué falló el sistema."
            htmlFor="vext-titulo"
            full
          >
            <TextInput
              id="vext-titulo"
              value={v?.mensajeBloqueo?.titulo ?? ""}
              onChange={(e) => onChange("validacionExterna.mensajeBloqueo.titulo", e.target.value)}
              placeholder={VALIDACION_EXTERNA_DEFAULT.mensajeBloqueo.titulo}
            />
          </Field>

          <Field
            label="Detalle del mensaje de bloqueo"
            hint="Deja siempre una salida: a quién escribir si cree que es un error."
            htmlFor="vext-detalle"
            full
          >
            <TextArea
              id="vext-detalle"
              rows={3}
              value={v?.mensajeBloqueo?.detalle ?? ""}
              onChange={(e) => onChange("validacionExterna.mensajeBloqueo.detalle", e.target.value)}
              placeholder={VALIDACION_EXTERNA_DEFAULT.mensajeBloqueo.detalle}
            />
          </Field>
        </>
      )}
    </div>
  );
}
